export default __webpack_public_path__ + "static/media/Shaka_particle_final_10.5adffa64.png";